import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import React, { createContext } from "react";

import { InitialDataContext } from './seo/InitialData';
import PageSeo from './seo/PageSeo';
import RouteEffects from './components/RouteEffects';
import SiteHeader from "./components/SiteHeader";
import SiteBottom from "./components/SiteBottom";
import Homepage from "./pages/Homepage.jsx";
import Collection from "./pages/Collection";
import CollectionItem from "./pages/CollectionItem";
import BlogItem from './pages/BlogItem';
import Links from './pages/Links';
import Platform from './pages/Platform';
import GameRelease from './pages/GameRelease';


export const AppContext = createContext();


function App({ RouterComponent = Router, location, initialData = {} }) {

  const strapiURL = process.env.REACT_APP_STRAPI_BASE_URL;

  return (

    <AppContext.Provider value={strapiURL}>
      <RouterComponent location={location}>
        <InitialDataContext.Provider value={initialData}>
        <div className="App">
          <a className="skip-link" href="#main-content">Przejdź do treści</a>
          <RouteEffects />
          <SiteHeader />
          <main id="main-content" tabIndex="-1">
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="/blog/:id" element={<BlogItem />} />
            <Route path="/collection" element={<Collection />} />
            <Route path="/collection/:id" element={<CollectionItem />} />
            <Route path="/links" element={<Links />} />
            <Route path="/platform/:slug" element={<Platform />} />
            <Route path="/games/:id" element={<GameRelease />} />
            {/* <Route path="/manufacturer/:id" element={<Manufacturer />} /> */}
            <Route path="*" element={<section className="retro-item-page"><div className="retro-item-inner"><PageSeo unavailable /><h1>Nie znaleziono strony</h1><p>Ten adres nie prowadzi do wpisu ani eksponatu.</p><a className="retro-button retro-button-primary" href="/collection">Przejdź do zbiorów</a></div></section>}/>
          </Routes>
          </main>
          <SiteBottom />
        </div>
      </InitialDataContext.Provider>
      </RouterComponent>
    </AppContext.Provider>
  );
}

export default App;
